import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/service/login.service';
import { cardsConfigV2 } from '../../../environments/environment';

@Component({
    selector: 'app-cards',
    template: ''
})
export class CardsComponent implements OnInit {
  // constructor(private redirectService: RedirectService) { }
  // ngOnInit(): void {
  //   this.redirectService.redirect(cardsConfig.redirectUri)
  // }

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = params['inApp'];
      if (inApp) {
        cardsConfigV2.redirectUri = cardsConfigV2.redirectUri + '&inApp=true';
      }
    });
  }

  ngOnInit(): void {
    this.loginService.login(cardsConfigV2);
  }
}
